import { ListItemPrimaryText } from 'lib/list';
import styled from 'styled-components';

const ContextMenuListItemPrimaryText = styled(ListItemPrimaryText)``;

export { ContextMenuListItemPrimaryText };
